import React from "react"
import ReactDOM from "react-dom/client"

import App from "./App"
import "./index.css"
import { RootErrorBoundary } from "./lib/components/RootErrorBoundary/RootErrorBoundary"
import { setupGlobalErrorHandlers } from "./lib/ts/errorEvent"
import reportWebVitals from "./reportWebVitals"
import { initSentry } from "./sentry"

initSentry()
setupGlobalErrorHandlers()

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement)
root.render(
	<React.StrictMode>
		<RootErrorBoundary>
			<App />
		</RootErrorBoundary>
	</React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
